module.exports = __webpack_public_path__ + "img/selected3-min.72b6ecd6.png";